import React, { Children, useEffect, useState } from 'react';

import { ISpecOfferProperties } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { FullWidthListContainer, ListContainer, NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { useClickOutside } from '~/src/helpers/hooks/useClickOutside';

import * as ST from './styled';

const defaultHoverIndex = -1;

interface IProps {
    characteristics?: ISpecOfferProperties,
}

const Сharacteristics = ({ characteristics }: IProps): JSX.Element | null => {
    const isDesktop = useMatchMediaByWidth(wideBreakpoints.mobile, true);

    const [hoverIndex, setHoverIndex] = useState(defaultHoverIndex);

    useEffect(() => {
        if (isDesktop && hoverIndex !== defaultHoverIndex) {
            setHoverIndex(defaultHoverIndex);
        }
    }, [hoverIndex, isDesktop]);

    useClickOutside(
        hoverIndex !== defaultHoverIndex,
        () => setHoverIndex(defaultHoverIndex),
    );

    if (!characteristics || !characteristics?.items.length) {
        return null;
    }

    const showFullView = (idx: number) => {
        if (isDesktop) {
            return;
        }
        setHoverIndex(idx);
    };

    const { title, items } = characteristics;

    return (
        <ListContainer $direction={'column'} $desktop={8} $mobile={16}>
            <H4 $withIndent={false} $smaller>{title}</H4>

            <FullWidthListContainer $direction={'column'} $size={8}>
                {Children.toArray(items.map((property, index) => (
                    <NonStaticContainer $united={{ $position: 'relative' }}>
                        <FullWidthListContainer $direction={'row'} $wrap={'nowrap'} $size={4} $justifyContent={'space-between'}>
                            <ST.CharacteristicsName
                                $smaller
                                $color={COLORS.TextSecondary}
                            >
                                {property.name}
                            </ST.CharacteristicsName>
                            <ST.CharacteristicsDevider/>
                            <ST.CharacteristicsValue
                                $smaller
                                isFullView={hoverIndex === index}
                                $color={COLORS.TextSecondary}
                                onClick={() => showFullView(index)}
                            >
                                {property.value}
                            </ST.CharacteristicsValue>
                        </FullWidthListContainer>
                    </NonStaticContainer>
                )))}
            </FullWidthListContainer>
        </ListContainer>
    );
};

export default Сharacteristics;
